import React, { useEffect, useState } from 'react';
import { AppBar, Menu, MenuItem, Toolbar, Box, alpha, Typography, Fade, IconButton, List, Drawer, ListItem, ListItemText, Avatar, Divider, Button, useTheme, useMediaQuery } from '@mui/material';
import LoginIcon from '@mui/icons-material/Login';
import LogoutIcon from '@mui/icons-material/Logout';
import { useNavigate, useLocation } from 'react-router-dom';
import ShoppingCart from './ShoppingCart';
import logoTachafy from '../assets/logo TACHAFY 1.png';
import ProfileLogo from '../assets/ProfileLogo.png';
import MenuIcon from '@mui/icons-material/Menu';
import { UserProfilePicture } from 'services/UserProfilePicture';
import { useAuth } from '../contexts/AuthContext';
import logoTachafyWhite from '../assets/logo TACHAFY white.png';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import image_not_found from '../assets/image_not_found.png';
import logoTachafyNew from '../assets/HomePage/tachafy-newLogo.png';
import ProfilePng from '../assets/Profile.png';
import PanierPng from '../assets/panier.png';
import LanguageIcon from '../assets/Vector (4).png';
import ProfilePartner from '../assets/partner/Profile (2).png';
import LanguagePartner from '../assets/partner/Vector (5).png';

const Header: React.FC = () => {
    const theme = useTheme();
    const navigate = useNavigate();
    const location = useLocation();
    const isSpecialRoute = ['/', '/home', '/partner-form', '/about-us'].includes(location.pathname);
    const { logout } = useAuth();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const userName = localStorage.getItem("userEmail") || "";
    const [mobileOpen, setMobileOpen] = useState(false);
    const role = JSON.parse(localStorage.getItem("Role") || '""');
    const userInfo = JSON.parse(localStorage.getItem("userInfo") || '""');
    const profilePicture = role === 'Professional'
        ? userInfo?.professionnel?.photo_url || ''
        : role === 'Partner'
            ? userInfo?.partenaire?.photo_url || ''
            : '';

    const [previewUrl, setPreviewUrl] = useState<string | null>(null);
    const isMobile = useMediaQuery('(max-width:1498px)', { noSsr: true });
    const [anchorElServices, setAnchorElServices] = useState<null | HTMLElement>(null);
    const openServicesMenu = Boolean(anchorElServices);
    const [openServicesMobile, setOpenServicesMobile] = useState(false);
    const [anchorElUnauth, setAnchorElUnauth] = useState<null | HTMLElement>(null);
    const [anchorElLanguage, setAnchorElLanguage] = useState<null | HTMLElement>(null);
    const [isScrolled, setIsScrolled] = useState(false);

    const openProfilePopUp = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const closeProfilePopUp = () => {
        setAnchorEl(null);
    };
    const openServicesPopUp = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorElServices(event.currentTarget);
    };
    const closeServicesPopUp = () => {
        setAnchorElServices(null);
    };
    const toggleDrawer = () => {
        setMobileOpen((prev) => !prev);
    };
    const handleDrawerToggle = (open: boolean) => () => {
        setMobileOpen(open);
    };
    const toggleServicesMobile = () => {
        setOpenServicesMobile((prev) => !prev);
    };
    const openUnauthPopUp = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorElUnauth(event.currentTarget);
    };
    const closeUnauthPopUp = () => {
        setAnchorElUnauth(null);
    };
    const openLanguageMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorElLanguage(event.currentTarget);
    };
    const closeLanguageMenu = () => {
        setAnchorElLanguage(null);
    };
    const handleLanguageSelect = (language: string) => {
        closeLanguageMenu();
    };

    useEffect(() => {
        const fetchProfilePicture = async () => {
            const userId = userInfo?.utilisateur?.id || userInfo?.id || null;
            if (!userId) return;

            try {
                const data = await UserProfilePicture.getProfilePicture(userId);

                if (data?.image_base64) {
                    setPreviewUrl(data.image_base64);
                } else {
                    setPreviewUrl(null);
                }
            } catch (error) {
                console.error("Erreur lors du chargement de la photo de profil :", error);
                setPreviewUrl(null);
            }
        };

        fetchProfilePicture();
    }, [userInfo?.utilisateur?.id]);

    useEffect(() => {
        const handleProfilePhotoUpdate = async () => {
            const userInfo = JSON.parse(localStorage.getItem("userInfo") || '{}');
            const userId = userInfo?.utilisateur?.id || userInfo?.id || null;

            if (!userId) return;

            try {
                const data = await UserProfilePicture.getProfilePicture(userId);

                if (data?.image_base64) {
                    setPreviewUrl(data.image_base64);
                } else {
                    setPreviewUrl(null);
                }
            } catch (error) {
                console.error('Erreur lors du rechargement de la photo de profil :', error);
                setPreviewUrl(null);
            }
        };

        window.addEventListener('profilePhotoUpdated', handleProfilePhotoUpdate);
        return () => {
            window.removeEventListener('profilePhotoUpdated', handleProfilePhotoUpdate);
        };
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            if (location.pathname === '/healixhome') {
                setIsScrolled(window.scrollY > 0);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [location.pathname]);

    const getDoctorFullName = () => {
        if (role === "Professional" && userInfo?.utilisateur) {
            const capitalize = (str: string) =>
                str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();

            const firstName = capitalize(userInfo.utilisateur.prenom || "");
            const lastName = capitalize(userInfo.utilisateur.nom || "");

            return `Dr, ${lastName} ${firstName}`;
        }
        return "";
    };

    const getUserFullName = () => {
        if (role === "Professional" && userInfo?.utilisateur) {
            const capitalize = (str: string) =>
                str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();

            const firstName = capitalize(userInfo.utilisateur.prenom || "");
            const lastName = capitalize(userInfo.utilisateur.nom || "");
            return `Dr, ${lastName} ${firstName}`;
        } else if (role === "Partner" && userInfo?.utilisateur) {
            const nom_entreprise = userInfo.partenaire.nom_entreprise || "";
            return nom_entreprise;
        }
        return "";
    };

    const userFullName = getUserFullName();

    const handleLogin = () => {
        navigate("/signIn", {
            state: {
                from: location
            },
            replace: true,
        });
    };
    
    const handleMenuClick = (label: string, path: string) => {
        setMobileOpen(false);
        window.location.href = path;
    };

    const handleLogout = () => {
        try { logout(); } catch {}
        navigate('/signIn', { replace: true });
    };
    
    const isAuthenticated = () => {
        return !!localStorage.getItem("userEmail");
    };
    
    const getMenuItems = (): { label: string; path: string }[] => {
        if (!isAuthenticated()) {
            return [
                { label: 'Healix', path: '/healixhome' },
                { label: 'Tele-Consult', path: '/teleconsultation' },
                { label: 'E-Pharmacy', path: '/EPharmacy' },
                { label: 'About', path: '/about-us' },
                { label: 'Blog', path: '/blogs' },
                { label: 'Contact', path: '/contact-us' },
                { label: 'For partner', path: '/partnerpage' },
            ];
        }

        return role !== 'client'
            ? []
            : [
                { label: 'Healix', path: '/healixhome' },
                { label: 'Tele-Consult', path: '/teleconsultation' },
                { label: 'E-Pharmacy', path: '/EPharmacy' },
                { label: 'About', path: '/about-us' },
                { label: 'Blog', path: '/blogs' },
                { label: 'Contact', path: '/contact-us' },
                { label: 'For partner', path: '/partnerpage' },
            ];
    };

    const menuItems = getMenuItems();

    // Build drawer menu items for mobile: ensure 'Home' exists and place 'Profile' last (after Contact) when authenticated
    const drawerMenuItems = (() => {
        const items = [...menuItems];
        // Remove any existing Home occurrences to avoid duplicates
        const filtered = items.filter(i => i.path !== '/home');
        const homeItem = { label: 'Home', path: '/home' };
        if (isAuthenticated()) {
            const profilePath = role === 'Professional' ? '/professional-profile' : role === 'Partner' ? '/partner-profile' : '/client-profile';
            // Profile should appear last, after Contact
            return [homeItem, ...filtered, { label: 'Profile', path: profilePath }];
        }
        return [homeItem, ...filtered];
    })();

    const buttonColor = location.pathname === '/partnerpage' ? '#131B5C' : '#fff';
    const profileIcon = location.pathname === '/partnerpage' ? ProfilePartner : ProfilePng;
    const languageIcon = location.pathname === '/partnerpage' ? LanguagePartner : LanguageIcon;

    const menuItemStyle = {
        fontFamily: 'Lato, sans-serif',
        fontWeight: 300,
        fontSize: '20px',
        color: location.pathname === '/partnerpage' ? '#131B5C' : '#fff',
        cursor: 'pointer',
        transition: 'font-weight 0.2s',
        outline: 'none',
        boxShadow: 'none',
        border: 'none',
        background: 'none',
        '&:hover, &:focus, &:active, &.Mui-focusVisible, &.Mui-selected': {
            color: location.pathname === '/partnerpage' ? '#131B5C' : '#fff',
            fontWeight: 700,
            outline: 'none',
            boxShadow: 'none',
            border: 'none',
            background: 'none',
        },
    };
    
    const getActiveStyle = (path: string) =>
        location.pathname === path
            ? {
                color: path === '/partnerpage' ? '#131B5C' : '#fff',
                fontWeight: 700,
            }
            : {};

    const isServicesActive = () => {
        return ['/skinDiagnosis', '/beautycoaching', '/teleconsultation'].includes(location.pathname);
    };

    const getHeaderBgColor = () => {
        if (role === 'Professional' || role === 'Partner') {
            return location.pathname === '/home' ? '#131B5C' : 'rgba(255, 255, 255, 0.8)';
        } else {
            if (location.pathname === '/healixhome') {
                return isScrolled ? '#717B61' : 'transparent';
            } else if (location.pathname === '/home' || location.pathname === '/partnerpage') {
                return location.pathname === '/home' ? '#131B5C' : 'transparent';
            } else if (isSpecialRoute) {
                return '#131B5C';
            } else {
                return '#717B61';
            }
        }
    };

    const renderProfileMenu = () => {
        const headerBg = getHeaderBgColor();
        const isTransparent = headerBg === 'transparent' || location.pathname === '/healixhome';
        const menuItemColor = location.pathname === '/partnerpage' ? '#131B5C' : '#fff';
        return (
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={closeProfilePopUp}
                TransitionComponent={Fade}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                PaperProps={{
                    elevation: 3,
                    sx: {
                        bgcolor: isTransparent ? 'transparent' : headerBg,
                        ...(isTransparent && { backdropFilter: 'blur(18px)' }),
                        color: menuItemColor,
                        mt: 1,
                        px: 2,
                        py: 1,
                        borderRadius: 2,
                        minWidth: !isMobile ? 120 : 160,
                        transition: 'all 0.22s cubic-bezier(.4,2,.6,1)',
                    },
                }}
            >
                <Typography variant="body1" sx={{ px: 1.5, py: 0.5, color: '#b0b0b0', fontSize: !isMobile ? '1.2rem' : '1.4rem' }}>
                    {userName}
                </Typography>
                {(role !== 'Professional' && role !== 'Partner') && (
                    <>
                        <MenuItem onClick={() => { closeProfilePopUp(); navigate('/client-profile'); }} sx={{ color: menuItemColor, fontSize: !isMobile ? '1.2rem' : '1.4rem', fontWeight: 600, borderRadius: 2, my: 0.5, '&:hover': { color: headerBg === '#717B61' ? '#C37559' : '#D0006F', fontWeight: 700, background: 'rgba(255,255,255,0.06)' }, transition: 'all 0.18s cubic-bezier(.4,2,.6,1)' }}>
                            Profile
                        </MenuItem>
                        {!isMobile && (
                            <>
                                <Divider sx={{ bgcolor: 'rgba(255,255,255,0.12)', my: 0.5 }} />
                                <MenuItem onClick={() => { closeProfilePopUp(); handleLogout(); }} sx={{ color: menuItemColor, fontSize: !isMobile ? '1.2rem' : '1.4rem', fontWeight: 600, borderRadius: 2, my: 0.5, '&:hover': { color: headerBg === '#717B61' ? '#C37559' : '#D0006F', fontWeight: 700, background: 'rgba(255,255,255,0.06)' }, transition: 'all 0.18s cubic-bezier(.4,2,.6,1)' }}>
                                    Logout
                                </MenuItem>
                            </>
                        )}
                    </>
                )}
                {(role === 'Professional' || role === 'Partner') && (
                    <>
                        <Divider sx={{ bgcolor: 'rgba(255,255,255,0.12)', my: 0.5 }} />
                        <MenuItem onClick={() => { closeProfilePopUp(); handleLogout(); }} sx={{ color: menuItemColor, fontSize: !isMobile ? '1.2rem' : '1.4rem', fontWeight: 600, borderRadius: 2, my: 0.5, '&:hover': { color: headerBg === '#717B61' ? '#C37559' : '#D0006F', fontWeight: 700, background: 'rgba(255,255,255,0.06)' }, transition: 'all 0.18s cubic-bezier(.4,2,.6,1)' }}>
                            Logout
                        </MenuItem>
                    </>
                )}
            </Menu>
        );
    };

    const renderUnauthMenu = () => {
        if (isMobile) return null;
        const headerBg = getHeaderBgColor();
        const isTransparent = headerBg === 'transparent' || location.pathname === '/healixhome';
        return (
            <Menu
                anchorEl={anchorElUnauth}
                open={Boolean(anchorElUnauth)}
                onClose={closeUnauthPopUp}
                TransitionComponent={Fade}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                PaperProps={{
                    elevation: 3,
                    sx: {
                        bgcolor: isTransparent ? 'transparent' : headerBg,
                        ...(isTransparent && { backdropFilter: 'blur(10px)' }),
                        color: isTransparent ? '#222' : '#fff',
                        mt: 1,
                        px: 2,
                        py: 1,
                        borderRadius: 2,
                        minWidth: 160,
                        transition: 'all 0.22s cubic-bezier(.4,2,.6,1)',
                    },
                }}
            >
                <MenuItem onClick={() => { closeUnauthPopUp(); handleLogin(); }} sx={{ color: isTransparent ? '#222' : '#fff', fontSize: '1.15rem', fontWeight: 600, borderRadius: 2, my: 0.5, '&:hover': { color: headerBg === '#717B61' ? '#C37559' : '#D0006F', fontWeight: 700, background: 'rgba(255,255,255,0.06)' }, transition: 'all 0.18s cubic-bezier(.4,2,.6,1)' }}>
                    Login
                </MenuItem>

            </Menu>
        );
    };

    const renderLanguageMenu = () => {
        const headerBg = getHeaderBgColor();
        const isTransparent = headerBg === 'transparent' || location.pathname === '/healixhome';
        return (
            <Menu
                anchorEl={anchorElLanguage}
                open={Boolean(anchorElLanguage)}
                onClose={closeLanguageMenu}
                TransitionComponent={Fade}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                PaperProps={{
                    elevation: 3,
                    sx: {
                        bgcolor: isTransparent ? 'transparent' : headerBg,
                        ...(isTransparent && { backdropFilter: 'blur(10px)' }),
                        color: location.pathname === '/partnerpage' ? '#131B5C' : '#fff',
                        mt: 1,
                        px: 2,
                        py: 1,
                        borderRadius: 2,
                        minWidth: !isMobile ? 100 : 140,
                        transition: 'all 0.22s cubic-bezier(.4,2,.6,1)',
                    },
                }}
            >
                <MenuItem onClick={() => handleLanguageSelect('en')} sx={{ color: location.pathname === '/partnerpage' ? '#131B5C' : '#fff', fontSize: !isMobile ? '1.0rem' : '1.2rem', fontWeight: 600, borderRadius: 2, my: 0.5, '&:hover': { color: headerBg === '#717B61' ? '#C37559' : '#D0006F', fontWeight: 700, background: 'rgba(255,255,255,0.1)' }, transition: 'all 0.18s cubic-bezier(.4,2,.6,1)' }}>
                    English
                </MenuItem>
                <MenuItem onClick={() => handleLanguageSelect('fr')} sx={{ color: location.pathname === '/partnerpage' ? '#131B5C' : '#fff', fontSize: !isMobile ? '1.0rem' : '1.2rem', fontWeight: 600, borderRadius: 2, my: 0.5, '&:hover': { color: headerBg === '#717B61' ? '#C37559' : '#D0006F', fontWeight: 700, background: 'rgba(255,255,255,0.1)' }, transition: 'all 0.18s cubic-bezier(.4,2,.6,1)' }}>
                    Français
                </MenuItem>
                <MenuItem onClick={() => handleLanguageSelect('ar')} sx={{ color: location.pathname === '/partnerpage' ? '#131B5C' : '#fff', fontSize: !isMobile ? '1.0rem' : '1.2rem', fontWeight: 600, borderRadius: 2, my: 0.5, '&:hover': { color: headerBg === '#717B61' ? '#C37559' : '#D0006F', fontWeight: 700, background: 'rgba(255,255,255,0.1)' }, transition: 'all 0.18s cubic-bezier(.4,2,.6,1)' }}>
                    العربية
                </MenuItem>
            </Menu>
        );
    };

    const getDrawerBg = () => {
        if (location.pathname === '/healixhome') {
            return 'transparent';
        }
        if (location.pathname === '/partnerpage') {
            return 'rgba(255, 255, 255, 0.98)';
        } else if (location.pathname === '/home' || isSpecialRoute) {
            return 'rgba(19, 27, 92, 0.98)';
        } else {
            return 'rgba(113, 123, 97, 0.98)';
        }
    };

    const getDrawerTextColor = () => {
        return location.pathname === '/partnerpage' ? '#131B5C' : '#fff';
    };

    if (role === 'Professional' || role === 'Partner') {
        return (
            <>
                <AppBar
                    position="fixed"
                    elevation={0}
                    sx={{
                        bgcolor: location.pathname === '/home' ? '#131B5C' : 'rgba(255, 255, 255, 0.8)',
                        borderBottom: location.pathname === '/partnerpage' ? '0px solid transparent' : `0px solid ${alpha(theme.palette.primary.main, 0.1)}`,
                        py: 1,
                        px: isMobile ? 1 : { xs: 2, sm: 5, md: 10, lg: '150px' },
                        width: '100%',
                        maxWidth: '100%',
                        boxSizing: 'border-box',
                        overflowX: 'hidden',
                        zIndex: (theme) => theme.zIndex.drawer + 1,
                    }}
                >
                    <Toolbar
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            width: '100%',
                            px: isMobile ? 1 : 0,
                            overflowX: 'hidden',
                        }}
                    >
                        <Box
                            component="img"
                            src={role === 'Professional' || role === 'Partner' ? logoTachafyNew : logoTachafy}
                            alt="Tachafy Logo"
                            sx={{
                                width: { xs: '100px', sm: '140px', md: '157px', lg: '180px' },
                                height: { xs: '22px', sm: '24px', md: '26px', lg: '32px' },
                                maxWidth: '100%',
                                maxHeight: '48px',
                                minWidth: '80px',
                                minHeight: '20px',
                                borderRadius: '6px',
                                cursor: 'pointer',
                                mr: isMobile ? '0px' : '20px',
                                objectFit: 'contain',
                                display: 'block',
                            }}
                            onClick={() => navigate('/home')}
                        />
                        {isMobile ? (
                            (role === 'Professional' || role === 'Partner') ? (
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.7, minWidth: 0 }}>
                                    <Typography
                                        sx={{
                                            fontFamily: 'Poppins',
                                            fontWeight: 400,
                                            fontSize: '1.2rem',
                                            color: '#222',
                                            whiteSpace: 'nowrap',
                                            mr: 1,
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            maxWidth: { xs: 240, sm: 380, md: 600 },
                                            lineHeight: 1.1,
                                            display: 'flex',
                                            alignItems: 'center',
                                            textTransform: 'uppercase',
                                        }}
                                    >
                                        {userFullName}
                                    </Typography>
                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                                        <Avatar
                                            src={previewUrl || undefined}
                                            alt="Photo de profil"
                                            sx={{
                                                width: 44,
                                                height: 44,
                                                cursor: 'pointer',
                                                border: '2.5px solid #e0e7ef',
                                                borderRadius: '50%',
                                                boxShadow: '0 2px 8px 0 rgba(30, 64, 175, 0.10)',
                                                transition: 'transform 0.22s cubic-bezier(.4,2,.6,1), box-shadow 0.22s cubic-bezier(.4,2,.6,1)',
                                                backgroundColor: '#f3f4f6',
                                                '&:hover': {
                                                    transform: 'scale(1.12)',
                                                    boxShadow: '0 6px 24px 0 rgba(30, 64, 175, 0.22), 0 0 0 4px #3b82f6',
                                                    outline: 'none',
                                                },
                                            }}
                                            onClick={openProfilePopUp}
                                        />
                                        {renderProfileMenu()}
                                    </Box>
                                </Box>
                            ) : (
                                <Box
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '6px',
                                        flexDirection: 'row',
                                        justifyContent: 'space-between',
                                    }}
                                >
                                    <IconButton
                                        onClick={toggleDrawer}
                                        edge="start"
                                        disableRipple
                                        sx={{
                                            mr: { xs: 0, sm: 2 },
                                            color: 'white',
                                            border: '1px solid white',
                                            borderRadius: '6px',
                                            padding: '6px',
                                            outline: 'none',
                                            '&:focus': {
                                                outline: 'none',
                                            },
                                        }}
                                    >
                                        <MenuIcon />
                                    </IconButton>
                                    {role === 'client' && <ShoppingCart />}
                                    <Drawer
                                        anchor="top"
                                        open={mobileOpen}
                                        onClose={toggleDrawer}
                                        PaperProps={{
                                            sx: {
                                                height: '50%',
                                                display: 'flex',
                                                alignItems: 'center',
                                            },
                                        }}
                                    >
                                        <List sx={{ top: '80px' }}>
                                            <ListItem disablePadding>
                                                <Box
                                                    sx={{
                                                        width: '100%',
                                                        padding: '16px',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        backgroundColor: '#f5f5f5',
                                                        borderBottom: '1px solid #ddd',
                                                    }}
                                                >
                                                    <Box
                                                        component="div"
                                                        sx={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            cursor: 'pointer',
                                                        }}
                                                    >
                                                        {isAuthenticated() ? (
                                                            <>
                                                                <Box
                                                                    component="img"
                                                                    src={ProfilePng}
                                                                    alt="Profile Icon"
                                                                    sx={{ width: 30, height: 30, objectFit: 'contain' }}
                                                                    onClick={openProfilePopUp}
                                                                />
                                                                {renderProfileMenu()}
                                                            </>
                                                        ) : (
                                                            <button
                                                                onClick={() => navigate('/signIn')}
                                                                style={{
                                                                    backgroundColor: '#0097B2',
                                                                    color: 'white',
                                                                    fontFamily: 'Lato',
                                                                    fontWeight: 600,
                                                                    borderRadius: '32.5px',
                                                                    padding: '10px 20px',
                                                                    border: 'none',
                                                                    cursor: 'pointer',
                                                                }}
                                                            >
                                                                Login
                                                            </button>
                                                        )}
                                                    </Box>
                                                </Box>
                                            </ListItem>
                                            {menuItems.map(({ label, path }) => (
                                                <ListItem button key={path} onClick={() => handleMenuClick(label, path)}>
                                                    <ListItemText primary={label} />
                                                </ListItem>
                                            ))}
                                        </List>
                                    </Drawer>
                                </Box>
                            )
                        ) : (
                            <>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 4,
                                    }}
                                >
                                    {menuItems.map(({ label, path }) => (
                                        <Box key={path} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', position: 'relative' }}>
                                            <Typography
                                                onClick={() => handleMenuClick(label, path)}
                                                sx={{
                                                    ...menuItemStyle,
                                                    ...getActiveStyle(path),
                                                    position: 'relative',
                                                    '&:hover::after, &:focus::after': {
                                                        width: '80%',
                                                        opacity: 1,
                                                    },
                                                    '::after': {
                                                        content: '""',
                                                        display: 'block',
                                                        position: 'absolute',
                                                        left: '10%',
                                                        bottom: -4,
                                                        width: location.pathname === path ? '80%' : '0%',
                                                        height: '3px',
                                                        borderRadius: 2,
                                                        background: '#d5006e',
                                                        transition: 'width 0.25s cubic-bezier(.4,2,.6,1), opacity 0.2s',
                                                        opacity: location.pathname === path ? 1 : 0,
                                                    },
                                                    '&:hover': {
                                                        textShadow: '0 2px 8px rgba(213,0,110,0.12)',
                                                    },
                                                }}
                                                tabIndex={0}
                                                onMouseDown={e => e.preventDefault()}
                                            >
                                                {label}
                                            </Typography>
                                        </Box>
                                    ))}
                                </Box>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                    {role === 'client' && <ShoppingCart />}
                                    <Box
                                        component="div"
                                        onClick={() => {
                                            if (!isAuthenticated()) {
                                                handleLogin();
                                            }
                                        }}
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            top: '8px',
                                            cursor: 'pointer',
                                        }}
                                    >
                                        <Box
                                            component="div"
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                cursor: 'pointer',
                                            }}
                                        >
                                            {isAuthenticated() ? (
                                                <>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.7, minWidth: 0 }}>
                                                        <Typography
                                                            sx={{
                                                                fontFamily: 'Poppins',
                                                                fontWeight: 400,
                                                                fontSize: 40,
                                                                color: '#222',
                                                                mr: 1,
                                                                overflow: 'hidden',
                                                                textOverflow: 'ellipsis',
                                                                maxWidth: { xs: 220, sm: 380, md: 600 },
                                                                lineHeight: 1.1,
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                textTransform: 'uppercase',
                                                            }}
                                                        >
                                                            {userFullName}
                                                        </Typography>
                                                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                                                            {(role === 'Professional' || role === 'Partner') ? (
                                                                <Avatar
                                                                    src={previewUrl || undefined}
                                                                    alt="Photo de profil"
                                                                    sx={{
                                                                        width: 44,
                                                                        height: 44,
                                                                        cursor: 'pointer',
                                                                        border: '2.5px solid #e0e7ef',
                                                                        borderRadius: '50%',
                                                                        boxShadow: '0 2px 8px 0 rgba(30, 64, 175, 0.10)',
                                                                        transition: 'transform 0.22s cubic-bezier(.4,2,.6,1), box-shadow 0.22s cubic-bezier(.4,2,.6,1)',
                                                                        backgroundColor: '#f3f4f6',
                                                                        '&:hover': {
                                                                            transform: 'scale(1.12)',
                                                                            boxShadow: '0 6px 24px 0 rgba(30, 64, 175, 0.22), 0 0 0 4px #3b82f6',
                                                                            outline: 'none',
                                                                        },
                                                                    }}
                                                                    onClick={openProfilePopUp}
                                                                />
                                                            ) : (
                                                                previewUrl ? (
                                                                    <Avatar
                                                                        src={previewUrl}
                                                                        alt="Profile"
                                                                        sx={{ width: 44, height: 44, cursor: 'pointer', backgroundColor: '#f3f4f6', transition: 'transform 0.22s cubic-bezier(.4,2,.6,1)', '&:hover, &:focus': { transform: 'scale(1.12)' } }} onClick={openProfilePopUp} />
                                                                ) : (
                                                                    <Box component="img" src={ProfilePng} alt="Profile Icon" sx={{ width: 26, height: 26, objectFit: 'contain' }} onClick={openProfilePopUp} />
                                                                )
                                                            )}
                                                        </Box>
                                                    </Box>
                                                    {renderProfileMenu()}
                                                </>
                                            ) : (
                                                <button
                                                    onClick={() => navigate('/signIn')}
                                                    style={{
                                                        backgroundColor: '#0097B2',
                                                        color: 'white',
                                                        fontFamily: 'Lato',
                                                        fontWeight: 600,
                                                        borderRadius: '32.5px',
                                                        padding: '10px 20px',
                                                        border: '2px solid #fff',
                                                        cursor: 'pointer',
                                                        boxShadow: '0 2px 8px 0 rgba(213,0,110,0.08)',
                                                        transition: 'background 0.2s, font-weight 0.2s, border 0.2s, transform 0.18s',
                                                        outline: 'none',
                                                    }}
                                                >
                                                    Login
                                                </button>
                                            )}
                                        </Box>
                                    </Box>
                                </Box>
                            </>
                        )}
                    </Toolbar>
                </AppBar>
                {location.pathname !== '/partnerpage' && !location.pathname.startsWith('/book-doctor/') && (
                    <div style={{ height: 56, minHeight: 0, width: '100%' }} />
                )}
            </>
        );
    }

    return (
        <>
            <AppBar
                position={location.pathname === '/partnerpage' ? 'absolute' : 'fixed'}
                elevation={0}
                sx={{
                    ...(location.pathname === '/healixhome'
                        ? { bgcolor: isScrolled ? '#717B61' : 'transparent' }
                        : location.pathname === '/partnerpage'
                            ? { bgcolor: 'transparent' }
                            : isSpecialRoute
                                ? { bgcolor: '#131B5C' }
                                : { bgcolor: '#717B61' }),
                    boxShadow: location.pathname === '/partnerpage' ? 'none' : isScrolled && location.pathname === '/healixhome' ? '0 6px 24px 0 rgba(113,123,97,0.10)' : location.pathname === '/healixhome' ? 'none' : '0 6px 24px 0 rgba(113,123,97,0.10)',
                    borderBottom: location.pathname === '/partnerpage' ? '0px solid transparent' : isScrolled && location.pathname === '/healixhome' ? '1.5px solid rgba(255,255,255,0.08)' : location.pathname === '/healixhome' ? '0px solid transparent' : '1.5px solid rgba(255,255,255,0.08)',
                    borderRadius: 0,
                    py: 1,
                    px: isMobile ? 1 : { xs: 2, sm: 5, md: 10, lg: '150px' },
                    width: '100%',
                    maxWidth: '100%',
                    boxSizing: 'border-box',
                    overflowX: 'hidden',
                    zIndex: (theme) => theme.zIndex.drawer + 1,
                    transition: 'background 0.3s, box-shadow 0.3s, border-radius 0.3s',
                }}
            >
                <Toolbar
                    sx={{
                        display: 'flex',
                        justifyContent: isMobile ? 'space-between' : 'space-between',
                        alignItems: 'center',
                        width: '100%',
                        px: isMobile ? 1 : 0,
                        overflowX: 'hidden',
                    }}
                >
                    {!isMobile && (
                       <Box
  component="img"
  src={location.pathname === '/partnerpage' ? logoTachafyNew : logoTachafyWhite}
  alt="Tachafy Logo"
  sx={{
    width: { xs: '90px', sm: '120px' }, 
    height: { xs: '16px', sm: '20px' }, 
    borderRadius: '0px',
    cursor: 'pointer',
    mr: '32px',
    p: 0,
    background: 'none',
    boxShadow: 'none',
    display: 'block',
    objectFit: 'contain',
  }}
  onClick={() => navigate('/home')}
/>

                    )}

                    {!isMobile && (
                        <>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                                <Typography
                                    sx={{ ...menuItemStyle, ...getActiveStyle('/healixhome') }}
                                    onClick={() => handleMenuClick('Healix', '/healixhome')}
                                    tabIndex={0}
                                    onMouseDown={e => e.preventDefault()}
                                >
                                    Healix
                                </Typography>
                                <Typography
                                    sx={{ ...menuItemStyle, ...getActiveStyle('/teleconsultation') }}
                                    onClick={() => handleMenuClick('Tele-Consult', '/teleconsultation')}
                                    tabIndex={0}
                                    onMouseDown={e => e.preventDefault()}
                                >
                                    Tele-Consult
                                </Typography>
                                <Typography
                                    sx={{ ...menuItemStyle, ...getActiveStyle('/EPharmacy') }}
                                    onClick={() => handleMenuClick('E-Pharmacy', '/EPharmacy')}
                                    tabIndex={0}
                                    onMouseDown={e => e.preventDefault()}
                                >
                                    E-Pharmacy
                                </Typography>
                                <Typography
                                    sx={{ ...menuItemStyle, ...getActiveStyle('/about-us') }}
                                    onClick={() => handleMenuClick('About', '/about-us')}
                                    tabIndex={0}
                                    onMouseDown={e => e.preventDefault()}
                                >
                                    About
                                </Typography>
                                <Typography
                                    sx={{ ...menuItemStyle, ...getActiveStyle('/blogs') }}
                                    onClick={() => handleMenuClick('Blog', '/blogs')}
                                    tabIndex={0}
                                    onMouseDown={e => e.preventDefault()}
                                >
                                    Blog
                                </Typography>
                                <Typography
                                    sx={{ ...menuItemStyle, ...getActiveStyle('/contact-us') }}
                                    onClick={() => handleMenuClick('Contact', '/contact-us')}
                                    tabIndex={0}
                                    onMouseDown={e => e.preventDefault()}
                                >
                                    Contact
                                </Typography>
                                <Typography
                                    sx={{ ...menuItemStyle, ...getActiveStyle('/partnerpage') }}
                                    onClick={() => handleMenuClick('For partner', '/partnerpage')}
                                    tabIndex={0}
                                    onMouseDown={e => e.preventDefault()}
                                >
                                    For partner
                                </Typography>
                            </Box>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                {!isAuthenticated() ? (
                                    <>
                                        <button
                                            onClick={() => navigate('/healix-multi-tree-survey')}
                                            style={{
                                                backgroundColor: 'transparent',
                                                color: buttonColor,
                                                fontFamily: 'Lato',
                                                fontWeight: 600,
                                                borderRadius: '32.5px',
                                                padding: '12px 28px',
                                                border: `2px solid ${buttonColor}`,
                                                cursor: 'pointer',
                                                marginLeft: '0px',
                                                boxShadow: '0 2px 8px 0 rgba(113,123,97,0.10)',
                                                transition: 'background 0.2s, font-weight 0.2s, border 0.2s, transform 0.18s',
                                                outline: 'none',
                                            }}
                                            onMouseOver={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.08)'; e.currentTarget.style.transform = 'scale(1.04)'; e.currentTarget.style.border = `2px solid ${buttonColor}`; }}
                                            onMouseOut={e => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.transform = 'none'; e.currentTarget.style.border = `2px solid ${buttonColor}`; }}
                                            onFocus={e => { e.currentTarget.style.fontWeight = '700'; e.currentTarget.style.border = `2px solid ${buttonColor}`; }}
                                            onBlur={e => { e.currentTarget.style.fontWeight = '600'; e.currentTarget.style.border = `2px solid ${buttonColor}`; }}
                                        >
                                            Start Your Journey
                                        </button>
                                        <Box component="img" src={profileIcon} alt="Profile Icon" sx={{ width: 22, height: 22, objectFit: 'contain', cursor: 'pointer' }} onClick={openUnauthPopUp} />
                                        {renderUnauthMenu()}
                                        <Box component="img" src={languageIcon} alt="Language Icon" sx={{ width: 22, height: 22, objectFit: 'contain', cursor: 'pointer' }} onClick={openLanguageMenu} />
                                        {renderLanguageMenu()}
                                    </>
                                ) : (
                                    <>
                                        <ShoppingCart />
                                        <Box sx={{ display: 'flex', alignItems: 'center', ml: 2 }}>
                                            {(role === 'Professional' || role === 'Partner') ? (
                                                <Avatar
                                                    src={previewUrl || undefined}
                                                    alt="Photo de profil"
                                                    sx={{
                                                        width: 44,
                                                        height: 44,
                                                        cursor: 'pointer',
                                                        border: '2.5px solid #e0e7ef',
                                                        borderRadius: '50%',
                                                        boxShadow: '0 2px 8px 0 rgba(30, 64, 175, 0.10)',
                                                        transition: 'transform 0.22s cubic-bezier(.4,2,.6,1), box-shadow 0.22s cubic-bezier(.4,2,.6,1)',
                                                        backgroundColor: '#f3f4f6',
                                                        '&:hover': {
                                                            transform: 'scale(1.12)',
                                                            boxShadow: '0 6px 24px 0 rgba(30, 64, 175, 0.22), 0 0 0 4px #3b82f6',
                                                            outline: 'none',
                                                        },
                                                    }}
                                                    onClick={openProfilePopUp}
                                                />
                                            ) : (
                                                previewUrl ? (
                                                    <Avatar
                                                        src={previewUrl}
                                                        alt="Profile"
                                                        sx={{ width: 44, height: 44, cursor: 'pointer', backgroundColor: '#f3f4f6', transition: 'transform 0.22s cubic-bezier(.4,2,.6,1)', '&:hover, &:focus': { transform: 'scale(1.12)' } }} onClick={openProfilePopUp} />
                                                ) : (
                                                    <Box component="img" src={ProfilePng} alt="Profile Icon" sx={{ width: 22, height: 22, objectFit: 'contain' }} onClick={openProfilePopUp} />
                                                )
                                            )}
                                            {renderProfileMenu()}
                                        </Box>
                                        <Box component="img" src={languageIcon} alt="Language Icon" sx={{ width: 22, height: 22, objectFit: 'contain', cursor: 'pointer' }} onClick={openLanguageMenu} />
                                        {renderLanguageMenu()}
                                    </>
                                )}
                            </Box>
                        </>
                    )}

                    {isMobile && (
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                                width: '100%',
                                gap: 1,
                            }}
                        >
                            <IconButton
                                onClick={toggleDrawer}
                                edge="start"
                                disableRipple
                                sx={{
                                    color: location.pathname === '/partnerpage' ? '#131B5C' : 'white',
                                    border: 'none',
                                    borderRadius: '50%',
                                    padding: '10px',
                                    outline: 'none',
                                    background: 'transparent',
                                    transition: 'transform 0.18s',
                                    '&:hover, &:focus': {
                                        background: 'transparent',
                                        boxShadow: 'none',
                                        transform: 'scale(1.08)',
                                    },
                                    '&:active': {
                                        background: 'transparent',
                                        boxShadow: 'none',
                                        transform: 'scale(0.97)',
                                    },
                                }}
                            >
                                <MenuIcon sx={{ fontSize: 32, transition: 'color 0.18s' }} />
                            </IconButton>

                            {role === 'client' && (
                                <Box sx={{ ml: 'auto' }}>
                                    <ShoppingCart />
                                </Box>
                            )}

                            <Drawer
                                anchor="left"
                                open={mobileOpen}
                                onClose={toggleDrawer}
                                PaperProps={{
                                    sx: {
                                        width: '60%',
                                        maxWidth: '22.5rem',
                                        height: '100vh',
                                        maxHeight: '100vh', // Ensure drawer doesn't exceed viewport height
                                        bgcolor: getDrawerBg(),
                                        backdropFilter: 'blur(1.25rem)',
                                        boxShadow: '0 0.5rem 2rem 0 rgba(0,0,0,0.18)',
                                        border: 'none',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'space-between',
                                        pt: '6rem',
                                        pb: '1.875rem',
                                        px: '1.25rem',
                                        overflow: 'hidden',
                                        // Responsive adjustments for smaller devices
                                        '@media (max-height: 700px)': {
                                            pt: '4rem',
                                            pb: '1rem',
                                        },
                                        '@media (max-height: 600px)': {
                                            pt: '3rem',
                                            pb: '0.75rem',
                                        },
                                    },
                                }}
                            >
                                <Box sx={{ flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column', minHeight: 0 }}>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            pb: '1.875rem',
                                            borderBottom: `0.0625rem solid ${location.pathname === '/partnerpage' ? 'rgba(19,27,92,0.15)' : 'rgba(255,255,255,0.15)'}`,
                                            mb: '1.25rem',
                                            flexShrink: 0, // Prevent header from shrinking
                                            '@media (max-height: 600px)': {
                                                pb: '1rem',
                                                mb: '0.75rem',
                                            },
                                        }}
                                    >
                                        {/* Profile is shown as a menu item below in the drawer list for mobile */}
                                        {renderUnauthMenu()}
                                    </Box>

                                    <List sx={{ 
                                        width: '100%', 
                                        py: 0, 
                                        flex: 1, 
                                        overflow: 'auto',
                                        overflowY: 'auto', // Enable vertical scrolling
                                        overflowX: 'hidden',
                                        minHeight: 0, // Allow list to shrink if needed
                                        '&::-webkit-scrollbar': {
                                            width: '4px',
                                        },
                                        '&::-webkit-scrollbar-thumb': {
                                            backgroundColor: location.pathname === '/partnerpage' ? 'rgba(19,27,92,0.3)' : 'rgba(255,255,255,0.3)',
                                            borderRadius: '4px',
                                        },
                                    }}>
                                        {drawerMenuItems.map((item) => (
                                            <ListItem
                                                button
                                                key={item.path}
                                                onClick={() => handleMenuClick(item.label, item.path)}
                                                sx={{
                                                    py: '0.9375rem',
                                                    px: '1.25rem',
                                                    borderRadius: '0.5rem',
                                                    mb: '0.3125rem',
                                                    transition: 'all 0.2s',
                                                    backgroundColor: location.pathname === item.path
                                                        ? location.pathname === '/partnerpage'
                                                            ? 'rgba(19,27,92,0.1)'
                                                            : 'rgba(255,255,255,0.1)'
                                                        : 'transparent',
                                                    '&:hover': {
                                                        backgroundColor: location.pathname === '/partnerpage'
                                                            ? 'rgba(19,27,92,0.08)'
                                                            : 'rgba(255,255,255,0.08)',
                                                    },
                                                    // More compact on smaller devices
                                                    '@media (max-height: 700px)': {
                                                        py: '0.75rem',
                                                        mb: '0.25rem',
                                                        '& .MuiListItemText-primary': {
                                                            fontSize: '1.3rem',
                                                        },
                                                    },
                                                    '@media (max-height: 600px)': {
                                                        py: '0.5rem',
                                                        mb: '0.125rem',
                                                        '& .MuiListItemText-primary': {
                                                            fontSize: '1.1rem',
                                                        },
                                                    },
                                                }}
                                            >
                                                <ListItemText
                                                    primary={item.label}
                                                    primaryTypographyProps={{
                                                        fontSize: '1.5rem',
                                                        fontWeight: location.pathname === item.path ? 700 : 500,
                                                        color: getDrawerTextColor(),
                                                        fontFamily: 'Lato, sans-serif',
                                                    }}
                                                />
                                            </ListItem>
                                        ))}
                                    </List>

                                    {/* Removed mobile "Start Your Journey" button per design */}
                                </Box>

                                <Box sx={{ 
                                    display: 'flex', 
                                    justifyContent: 'space-between', 
                                    alignItems: 'center', 
                                    pt: '1.25rem', 
                                    borderTop: `0.0625rem solid ${location.pathname === '/partnerpage' ? 'rgba(19,27,92,0.15)' : 'rgba(255,255,255,0.15)'}`,
                                    flexShrink: 0, // Prevent footer from shrinking
                                    '@media (max-height: 600px)': {
                                        pt: '0.75rem',
                                    },
                                }}>
                                    <Box
                                        component="img"
                                        src={languageIcon}
                                        alt="Language Icon"
                                        sx={{
                                            width: '1.25rem',
                                            height: '1.25rem',
                                            objectFit: 'contain',
                                            cursor: 'pointer',
                                            filter: location.pathname === '/partnerpage' ? 'none' : 'brightness(0) invert(1)',
                                            transition: 'transform 0.18s',
                                            '&:hover': { transform: 'scale(1.1)' },
                                        }}
                                        onClick={openLanguageMenu}
                                    />
                                    {renderLanguageMenu()}
                                    {isAuthenticated() ? (
                                        <Button
                                            onClick={() => { setMobileOpen(false); handleLogout(); }}
                                            startIcon={<LogoutIcon />}
                                            sx={{
                                                color: getDrawerTextColor(),
                                                border: `0.125rem solid ${getDrawerTextColor()}`,
                                                backgroundColor: 'transparent',
                                                '&:hover': {
                                                    backgroundColor: location.pathname === '/partnerpage' ? 'rgba(19,27,92,0.1)' : 'rgba(255,255,255,0.1)',
                                                },
                                                borderRadius: '2.03125rem',
                                                padding: '0.5rem 1rem',
                                                fontFamily: 'Lato',
                                                fontWeight: 600,
                                                textTransform: 'none',
                                                fontSize: '0.9rem',
                                            }}
                                        >
                                            Logout
                                        </Button>
                                    ) : (
                                        <Button
                                            onClick={() => { setMobileOpen(false); navigate('/signIn'); }}
                                            startIcon={<LoginIcon />}
                                            sx={{
                                                color: getDrawerTextColor(),
                                                border: `0.125rem solid ${getDrawerTextColor()}`,
                                                backgroundColor: 'transparent',
                                                '&:hover': {
                                                    backgroundColor: location.pathname === '/partnerpage' ? 'rgba(19,27,92,0.1)' : 'rgba(255,255,255,0.1)',
                                                },
                                                borderRadius: '2.03125rem',
                                                padding: '0.5rem 1rem',
                                                fontFamily: 'Lato',
                                                fontWeight: 600,
                                                textTransform: 'none',
                                                fontSize: '0.9rem',
                                            }}
                                        >
                                            Login
                                        </Button>
                                    )}
                                </Box>
                            </Drawer>
                        </Box>
                    )}
                </Toolbar>
            </AppBar>

            {location.pathname !== '/partnerpage' && location.pathname !== '/healixhome' && !location.pathname.startsWith('/book-doctor/') && (
                <div style={{ height: 56, minHeight: 0, width: '100%' }} />
            )}
        </>
    );
};

export default Header;